import React, { Component } from 'react';
import { connect } from 'react-redux';

export default function (ComposedComponent) {
  class Authentication extends Component {
    redirect() {
      window.location = '/login';
      return null;
    }

    render() {
      if (!this.props.user) return this.redirect();

      return <ComposedComponent {...this.props} />;
    }
  }

  return connect(({ users }) => ({ user: users.byId[users.current] }))(Authentication);
}



// WEBPACK FOOTER //
// ./src/components/hoc/require-authentication.js